import Box from '@zenbusiness/zui/Box';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const InfoImage = superstyled({
  tag: Box,
  name: 'InformationSection',
  slot: 'InfoImage',
  styles: ({ theme }) => ({
    width: '100%',
    borderRadius: theme.shape.rounded.xl,
    overflow: 'hidden',
    height: 'fit-content',

    [theme.breakpoints.up('lg')]: {
      marginTop: '3.25rem',
      flex: 1,
    },
  }),
});

export const InnerStack = superstyled({
  tag: Stack,
  name: 'InformationSection',
  slot: 'InnerStack',
  styles: ({ theme }) => ({
    maxWidth: '100%',
    flex: 1,

    [theme.breakpoints.up('lg')]: {
      maxWidth: '50%',
    },
  }),
});
